import React, { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
// import Modal from "react-modal";
import Invoice from "./Invoice";
import AuthUser from "../AuthUser";
import "../../CSS/Invoice.css";
import http from "../../http";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import SalesReturnModal from "../SalesComponent/SalesReturnModal";
import moment from "moment";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";
import { Modal as ReactModal } from "./Modal";
import { appContext } from "../../navbar/auth";
const RightSidebar = ({
  pImage,
  setPImage,
  setSearchMedicine,
  invoiceData,
  setInvoiceData,
}) => {
  const [error, setError] = useState("");
  const lan = useLanguage(cashierLang);
  const { user } = AuthUser();
  // Context Api Start
  const {
    setPaymentMethod,
    paymentMethod,
    invoiceReload,
    setInvoiceReload,
    setCart,
    cart,
    allSubTotal,
    allSubTotalWithoutDiscount,
    invoice,
    setInvoiceId,
    invoiceId,
    isSpecialDiscount,
    setSpecialDiscount,
    specialDiscount,
    returnAmount,
    setReturnAmount,
    setUpdateTrack,
    updateTrack,
    paymentStatus,
    selectedInvoice,
    setSelectedInvoice,
    setAutoReloadInvoice,
    autoReloadInvoice,
    prescriptionImage,
    setPrescriptionImage,
    paidAmount,
    setPaidAmount,
  } = useContext(appContext);
  const {
    customer_type,
    date,
    delivery_charge,
    last_due,
    last_due_date,
    member_id,
    receiver_name,
    receiver_address,
    previous_due,
    previous_due_date,
    transport,
    due,
  } = invoiceData;
  const [cardType, setCardType] = useState("Visa Card");
  const [digitalType, setDigitalType] = useState("");
  // Context Api end
  const handleChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setPaymentMethod(value);
    } else {
      setPaymentMethod("Cash");
    }
  };

  const handleCartChange = (event) => {
    setCardType(event.target.value);
  };

  const [grandTotal, setGrandTotal] = useState(0);
  const [specialDiscountType, setSpecialDiscountType] = useState("Fixed");
  const [invoiceAllTotal, setInvoiceAllTotal] = useState(0);

  // Sales side Discount

  const [modalIsOpen, setIsOpen] = useState(false);

  const partialInvoice =
    selectedInvoice?.paid_amount > 0 &&
    selectedInvoice?.due_amount > 0 &&
    selectedInvoice?.payment_status === "Partially Paid"
      ? true
      : false;

  useEffect(() => {
    if (
      selectedInvoice?.paid_amount > 0 &&
      selectedInvoice?.due_amount > 0 &&
      selectedInvoice?.payment_status === "Partially Paid"
    ) {
      setGrandTotal(parseFloat(selectedInvoice?.present_due));
      setInvoiceAllTotal(parseFloat(selectedInvoice?.sub_total));
    } else {
      setInvoiceAllTotal(parseFloat(allSubTotalWithoutDiscount).toFixed(2));
      setGrandTotal(parseFloat(invoiceAllTotal - specialDiscount).toFixed(2));
    }
  }, [
    allSubTotal,
    specialDiscount,
    allSubTotalWithoutDiscount,
    paymentMethod,
    modalIsOpen,
    cart,
    delivery_charge,
    invoiceAllTotal,
  ]);

  // For payment calculation
  const handlePay = (e) => {
    if (paymentMethod === "Credit Payment") {
      setPaidAmount();
    } else {
      setPaidAmount(parseFloat(e.target.value || 0));
    }
  };

  useEffect(() => {
    if (paidAmount > grandTotal) {
      const r = (parseFloat(paidAmount) - parseFloat(grandTotal))?.toFixed(2);
      setReturnAmount(r);
    } else {
      setReturnAmount(0);
    }
  }, [grandTotal, paidAmount]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  useEffect(() => {
    http.get("payment-method").then((res) => {
      setPaymentMethods(res.data);
    });
  }, []);

  // Clear information
  const clearInformation = (info) => {
    setCart([]);
    setInvoiceReload(!invoiceReload);
    setIsOpen(false);
    // setCurrentMember({});
    setInvoiceId();
    setSpecialDiscount(0);
    setReturnAmount(0);
    setPaymentMethod("Cash");
    setPaidAmount();
    setPrescriptionImage("");
    setPImage("");
    setSearchMedicine("");
    setSelectedInvoice({});
    setSpecialDiscount("0");
    setInvoiceData({
      customer_type: "customer",
      date: new Date(),
      delivery_charge: "",
      last_due: "",
      last_due_date: "",
      member_id: "",
      receiver_name: "",
      receiver_address: "",
      previous_due: "",
      previous_due_date: "",
      transport: "",
      due: "",
    });
    pImage.value = "";
    Swal.fire({
      position: "top-center",
      icon: "success",
      title: `${info} !`,
      text: "Your data has been saved",
      timer: 1000,
    });
  };
  const [digitalNumber, setDigitalNumber] = useState("");
  const handleDigitalNumber = (e) => {
    let { value } = e.target;
    // value = Math.max(parseFloat(min), Math.min(parseFloat(max), parseFloat(value)));
    setDigitalNumber(value);
  };
  // Special percentage calculation
  const handleSpecialPercentage = (e) => {
    if (specialDiscountType === "Fixed" && e.target.value.length > 0) {
      let { value } = e.target;
      setSpecialDiscount(value);
    } else if (
      specialDiscountType === "Percentage" &&
      e.target.value.length > 0
    ) {
      let { value, min, max } = e.target;
      value = Math.max(
        parseFloat(min),
        Math.min(parseFloat(max), parseFloat(value))
      );
      let total = invoiceAllTotal - parseFloat(delivery_charge);
      setSpecialDiscount((parseInt(total) * value) / 100);
    } else {
      setSpecialDiscount(0);
    }
  };
  const [loading, setLoading] = useState(false);

  // print invoice
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      clearInformation("Invoice Create");
    },
  });
  const handlePrintPreview = useReactToPrint({
    content: () => componentRef.current,
  });

  // Create New Invoice
  const handleInvoiceGenerate = () => {
    const newCart = cart.filter((c) => parseInt(c.pcs) > 0);
    const formData = new FormData();
    formData.append("invoice_no", invoice);
    formData.append("sub_total", invoiceAllTotal);
    formData.append("vat_tax_amount", 0);
    formData.append("payment_status", "Unpaid");
    formData.append("grand_total", invoiceAllTotal);
    formData.append(
      "discount_type",
      paymentMethod === "Digital Payment"
        ? `${paymentMethod?.charAt(0)?.toUpperCase()} -  
        ${digitalType?.charAt(0)?.toUpperCase()} : ${digitalNumber} `
        : paymentMethod === "Card"
        ? `${paymentMethod?.charAt(0)?.toUpperCase()} -
         ${cardType?.charAt(0)?.toUpperCase()} : : ${digitalNumber}`
        : paymentMethod
    );
    formData.append("discount_amount", 0);

    formData.append("special_discount", specialDiscount);
    formData.append("paid_amount", 0);
    formData.append("return_amount", returnAmount);

    formData.append("prescription_image", prescriptionImage);
    formData.append("invoice_from", "web");
    formData.append("created_by", user?.name ? user?.name : "");
    // new field
    formData.append("customer_type", customer_type);
    formData.append("date", moment(date).format("YYYY-MM-DD HH:mm:ss"));
    formData.append("delivery_charge", delivery_charge);
    formData.append("receiver_name", receiver_name);
    formData.append("receiver_address", receiver_address);
    formData.append("member_id", member_id);
    formData.append("last_due_date", last_due_date);
    formData.append("last_due", last_due);
    formData.append("previous_due_date", previous_due_date);
    formData.append("previous_due", previous_due);
    formData.append("transport", transport);

    formData.append("cart", JSON.stringify(newCart));

    http.post("invoice", formData).then((res) => {
      setAutoReloadInvoice(!autoReloadInvoice);
      if (res.data.status === 200) {
        handlePrint();
      } else {
        // console.log("res.data.errors",res.data.errors);
        setError(res.data.errors);
      }
    });
  };

  const handleUpdate = () => {
    setUpdateTrack(!updateTrack);
    setLoading(true);
    const id = invoiceId;
    const newCart = cart.filter((c) => parseInt(c?.pcs) > 0);

    if (id) {
      const formData = new FormData();
      formData.append("invoice_no", invoice);
      // formData.append('member_id', memberId)

      formData.append("sub_total", invoiceAllTotal);
      formData.append("vat_tax_amount", 0);
      formData.append(
        "payment_status",
        paymentMethod === "Credit Payment"
          ? "Unpaid"
          : paidAmount < grandTotal
          ? "Partially Paid"
          : "Paid"
      );
      formData.append(
        "due_amount",
        paidAmount > 0
          ? paidAmount >= grandTotal
            ? 0
            : grandTotal - paidAmount
          : selectedInvoice?.due_amount
      );
      formData.append(
        "delete_status",
        paymentMethod === "Credit Payment"
          ? "null"
          : moment().format("YYYY-MM-DD")
      );

      formData.append("special_discount", specialDiscount);
      formData.append(
        "paid_amount",
        partialInvoice
          ? parseFloat(paidAmount) + parseFloat(selectedInvoice?.paid_amount)
          : paidAmount
      );
      formData.append("return_amount", returnAmount);

      formData.append("grand_total", invoiceAllTotal);
      formData.append(
        "discount_type",
        paymentMethod === "Digital Payment"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()} -  
        ${digitalType?.charAt(0)?.toUpperCase()} : ${digitalNumber} `
          : paymentMethod === "Card"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()} -
         ${cardType?.charAt(0)?.toUpperCase()} : : ${digitalNumber}`
          : paymentMethod
      );
      formData.append("discount_amount", 0);

      formData.append("prescription_image", prescriptionImage);
      formData.append("invoice_from", "web");
      formData.append("cart", JSON.stringify(newCart));
      formData.append("updated_by", user?.name ? user?.name : "");
      formData.append("due_paid", paidAmount);

      http.post(`invoice/update/${id}`, formData).then((res) => {
        setLoading(true);
        if (res.data.status === 200) {
          setLoading(false);
          setIsOpen(false);
          // http
          //   .post(`stock-out-multiple`, {
          //     invoice_id: id,
          //     invoice_no: invoice,
          //     arrData: JSON.stringify(newCart),
          //   })
          //   .then((res) => {
          //     console.log(res, "stock-out-multiple");
          //   });

          // Swal.fire({
          //     position: 'top-center',
          //     icon: 'success',
          //     title: "Payment Done",
          //     timer: 1000
          // })
          clearInformation("Payment Done");
        } else {
          setError(res.data.errors);
        }
      });
    } else {
      const formData = new FormData();

      // formData.append('invoice_no', invoice)

      formData.append("sub_total", invoiceAllTotal);
      formData.append("vat_tax_amount", 0);
      formData.append(
        "payment_status",
        paymentMethod === "Credit Payment"
          ? "Unpaid"
          : paidAmount < grandTotal
          ? "Partially Paid"
          : "Paid"
      );
      formData.append(
        "due_amount",
        paymentMethod === "Credit Payment"
          ? grandTotal
          : paidAmount >= grandTotal
          ? 0
          : grandTotal - paidAmount
      );
      formData.append(
        "delete_status",
        paymentMethod === "Credit Payment"
          ? "null"
          : moment().format("YYYY-MM-DD")
      );

      formData.append("grand_total", invoiceAllTotal);
      formData.append(
        "discount_type",
        paymentMethod === "Digital Payment"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()}-${digitalType
              ?.charAt(0)
              ?.toUpperCase()} : ${digitalNumber} `
          : paymentMethod === "Card"
          ? `${paymentMethod?.charAt(0)?.toUpperCase()} - ${cardType
              ?.charAt(0)
              ?.toUpperCase()}:${digitalNumber}`
          : paymentMethod
      );
      formData.append("discount_amount", 0);

      formData.append("special_discount", specialDiscount);
      formData.append("paid_amount", paidAmount || 0);
      formData.append("return_amount", returnAmount);

      formData.append("prescription_image", prescriptionImage);
      formData.append("invoice_from", "web");
      formData.append("created_by", user?.name ? user?.name : "");
      // new field
      formData.append("customer_type", customer_type);
      formData.append("date", moment(date).format("YYYY-MM-DD HH:mm:ss"));
      formData.append("delivery_charge", delivery_charge);
      formData.append("receiver_name", receiver_name);
      formData.append("receiver_address", receiver_address);
      formData.append("member_id", member_id);
      formData.append("last_due_date", last_due_date);
      formData.append("last_due", last_due);
      formData.append("previous_due_date", previous_due_date);
      formData.append("previous_due", previous_due || 0);
      formData.append("due", due || 0);
      formData.append("transport", transport);
      formData.append("cart", JSON.stringify(newCart));
      http.post("invoice", formData).then((res) => {
        setAutoReloadInvoice(!autoReloadInvoice);

        if (res.data.status === 200) {
          setLoading(false);
          setIsOpen(false);
          // http
          //   .post(`stock-out-multiple`, {
          //     invoice_id: res.data.invoice.id,
          //     invoice_no: invoice,
          //     arrData: JSON.stringify(newCart),
          //   })
          //   .then((res) => {
          //     console.log(res, "stock-out-multiple");
          //   });
          handlePrint();
          //   setCurrentMember({});
        } else {
          // console.log("res.data.errors",res.data.errors);
          setError(res.data.errors);
        }
      });
    }
  };
  console.log(invoiceData, "grandTotal");
  // Modal
  return (
    <div className=" mt-2">
      {(selectedInvoice?.fully_return == null ||
        selectedInvoice?.fully_return === "null") && (
        <>
          {cart.length > 0 && (
            <div className="d-flex justify-content-end ">
              <span className="cart-sub-total me-md-2 me-lg-4 mt-2 fw-bold fs-5">
                {" "}
                {lan?.subTotal} : {Number(allSubTotal).toFixed(2)}
              </span>

              {invoiceId ? (
                (user.user_type === "cashier" ||
                  user.user_type === "admin" ||
                  user.user_type === "manager") &&
                (paymentStatus === "Unpaid" ||
                  paymentStatus === "Partially Paid") &&
                allSubTotalWithoutDiscount > 0 ? (
                  <>
                    <button
                      style={{ backgroundColor: "#69B128", color: "white" }}
                      onClick={() => {
                        setIsOpen(true);
                        setPaidAmount();
                        setPaymentMethod("Cash");
                      }}
                      className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                    >
                      {lan?.payNow}
                    </button>
                    {(paymentMethod === "Credit Payment" ||
                      paymentStatus === "Partially Paid") && (
                      <SalesReturnModal
                        clearInformation={clearInformation}
                        invoiceId={invoiceId}
                      />
                    )}
                  </>
                ) : paymentStatus === "Paid" ? (
                  <>
                    <SalesReturnModal
                      clearInformation={clearInformation}
                      invoiceId={invoiceId}
                    />
                  </>
                ) : (
                  <button
                    style={{ backgroundColor: "#69B128", color: "white" }}
                    onClick={() => {
                      setIsOpen(true);
                      setPaidAmount();
                    }}
                    className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                  >
                    {lan?.payNow}
                  </button>
                )
              ) : (user?.user_type === "cashier" ||
                  user?.user_type === "admin" ||
                  user?.user_type === "manager") &&
                (paymentStatus === "Unpaid" || paymentStatus === "Default") &&
                allSubTotalWithoutDiscount > 0 ? (
                <button
                  style={{ backgroundColor: "#69B128", color: "white" }}
                  onClick={() => {
                    setIsOpen(true);
                    setPaidAmount();
                  }}
                  className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                >
                  {lan?.payNow}
                </button>
              ) : (
                Number(allSubTotal) > 0 && (
                  <button
                    style={{ backgroundColor: "#69B128", color: "white" }}
                    onClick={() => {
                      handleInvoiceGenerate();
                    }}
                    className="btn btn-sm mt-2 me-lg-2 px-4 fw-bold"
                  >
                    {lan?.save}{" "}
                  </button>
                )
              )}
            </div>
          )}
        </>
      )}

      <ReactModal
        isOpen={modalIsOpen}
        onClose={() => setIsOpen(false)}
        size="lg"
        width="100%"
      >
        <ReactModal.Header onClose={() => setIsOpen(false)}>
          <ReactModal.Title>Payment</ReactModal.Title>
        </ReactModal.Header>
        <ReactModal.Body>
          <div className="g-doc-scroll">
            {/* <div className="row right-sidebar-head border-bottom">
              <div className="col-3 text-center border-end">
                <span className="right-side-cash-count d-block">
                  {lan?.counter}
                </span>
                <span className="right-side-cash-count-number d-block">1</span>
              </div>
              <div className="col-9 d-flex justify-content-between align-items-center px-2">
                <div className="text-center right-sidebar-cashier">
                  <h6>{user.name}</h6>
                  <span>
                    {" "}
                    {lan?.userRole}: {user.user_type}
                  </span>
                </div>
                <div className="text-center right-sidebar-cashier-img">
                  {user?.photo ? (
                    <img src={user.photo} alt="" />
                  ) : (
                    <img src={cashier} alt="" />
                  )}
                </div>
              </div>
            </div> */}
            <div className="pos-payment-method-container mt-2">
              <div className="row">
                {/* Cash payment  */}
                <div className="col-6">
                  <div className="d-flex justify-content-between mb-2">
                    <h6 className="pos-right-heading mb-1">
                      {lan?.paymentMethod}
                    </h6>
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        name="paymentMethod"
                        value="Credit Payment"
                        id="credit_payment"
                        onChange={handleChange}
                        // disabled={paymentMethod === "Credit Payment"}
                      />
                      <label className="pt-1 ps-2" htmlFor="credit_payment">
                        {lan?.creditPayment}
                      </label>
                    </div>
                  </div>
                  <Select
                    options={paymentMethods}
                    placeholder={lan?.select}
                    onChange={(e) => setPaymentMethod(e.name)}
                    getOptionLabel={(unPaidInvoices) =>
                      `${unPaidInvoices?.name}`
                    }
                    getOptionValue={(unPaidInvoices) => `${unPaidInvoices.id}`}
                    value={paymentMethods.find(
                      (method) => method.name === paymentMethod
                    )}
                    tabIndex={-1}
                    isDisabled={paymentMethod === "Credit Payment"}
                  />
                </div>
                {/* Card payment  */}
                <div className="col-6">
                  <div className="border rounded p-2 mt-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>Previous Due </h6>
                      <div className="d-flex">
                        <h6>{invoiceData?.due}</h6>
                      </div>
                    </div>

                    {paymentMethod === "Card" &&
                      user.user_type === "cashier" && (
                        <div className="mt-1 payment-card">
                          <div className="row">
                            <div className="p-2  mb-2 d-flex gap-2 ms-1">
                              <div className="radio-container">
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="visa"
                                    value="Visa Card"
                                    id="visa"
                                    checked={cardType === "Visa Card"}
                                    onChange={handleCartChange}
                                  />
                                  <label
                                    className="pt-1 ps-2"
                                    htmlFor="Visa Card"
                                  >
                                    Visa
                                  </label>
                                </div>
                              </div>

                              <div className="radio-container">
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="MasterCard"
                                    value="Master Card"
                                    id="MasterCard"
                                    checked={cardType === "Master Card"}
                                    onChange={handleCartChange}
                                  />
                                  <label
                                    className="pt-1 ps-2"
                                    htmlFor="Master Card"
                                  >
                                    Master Card
                                  </label>
                                </div>
                              </div>

                              <div className="radio-container">
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="AmericanExpress"
                                    value="American Express"
                                    id="AmericanExpress"
                                    checked={cardType === "American Express"}
                                    onChange={handleCartChange}
                                  />
                                  <label
                                    className="pt-1 ps-2"
                                    htmlFor="American Express"
                                  >
                                    American Express
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-5 ">
                              <label>{cardType} No.</label>
                            </div>
                            <div className="col-7 ">
                              <input
                                type="number"
                                min="11"
                                max="13"
                                onChange={handleDigitalNumber}
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className={`pos-invoice-preview px-2 mt-2 `}>
                  <h6 className="pos-right-heading">{lan?.invoicePreview}</h6>
                  <div className="pos-invoice-content m-2 p-2">
                    <div className="invoice-item mt-1 d-flex">
                      <span className="invoice-sub-item">{lan?.total}</span>
                      <span className="invoice-item-price w-100 text-end">
                        {invoiceAllTotal > 0
                          ? (
                              parseFloat(invoiceAllTotal) -
                              parseFloat(delivery_charge || 0)
                            ).toFixed(2)
                          : "0.00"}
                      </span>
                    </div>
                    <div className="invoice-item mt-1 d-flex">
                      <span className="invoice-sub-item">
                        {" "}
                        {lan?.discount}{" "}
                      </span>{" "}
                      <span className="invoice-item-price text-end w-100">
                        {" "}
                        {specialDiscount > 0 ? specialDiscount : "0.00"}
                      </span>
                    </div>
                    {selectedInvoice?.special_discount ? (
                      <></>
                    ) : (
                      <div className="ms-1 special-discount-container p-1 row">
                        <div className="col-9">
                          <div>
                            <input
                              onChange={() => {
                                setSpecialDiscountType("Fixed");
                                setSpecialDiscount("");
                              }}
                              type="radio"
                              defaultChecked={
                                specialDiscountType === "Fixed" && true
                              }
                              name="disc"
                            />
                            <label>{lan?.fixed}</label>
                          </div>
                          <div>
                            <input
                              onChange={() => {
                                setSpecialDiscountType("Percentage");
                                setSpecialDiscount("");
                              }}
                              type="radio"
                              name="disc"
                            />
                            <label>{lan?.percentage}</label>
                          </div>
                        </div>
                        <div className="col-3">
                          {specialDiscountType === "Fixed" ? (
                            <input
                              type="number"
                              onChange={(e) => handleSpecialPercentage(e)}
                              className="form-control form-control-sm mt-1 text-end"
                            />
                          ) : (
                            <input
                              type="number"
                              onChange={(e) => handleSpecialPercentage(e)}
                              min="1"
                              max="100"
                              className="form-control form-control-sm mt-1 text-end"
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {/* <div className="invoice-item mt-1 d-flex">
                      <span className="invoice-sub-item">{lan?.vatTax}</span>{" "}
                      <span className="invoice-item-price text-end w-100">
                        0
                      </span>
                    </div> */}
                    <div className="row">
                      <div className="col-9">
                        <span className="invoice-sub-item mt-2">
                          Delivery Charge
                        </span>
                      </div>
                      <div className="col-3 text-end">
                        {selectedInvoice?.id ? (
                          <span className="invoice-item-price text-end w-100">
                            {selectedInvoice?.delivery_charge}
                          </span>
                        ) : (
                          <input
                            type="number"
                            onChange={(e) =>
                              setInvoiceData({
                                ...invoiceData,
                                delivery_charge: e.target.value,
                              })
                            }
                            className="form-control form-control-sm mt-1 text-end"
                            value={invoiceData?.delivery_charge}
                          />
                        )}
                      </div>
                    </div>
                    {partialInvoice ? (
                      <>
                        <div className="invoice-item mt-1 d-flex">
                          <span className="invoice-sub-item">{lan?.paid}</span>{" "}
                          <span className="invoice-item-price text-end w-100">
                            {selectedInvoice?.paid_amount > 0
                              ? selectedInvoice?.paid_amount
                              : "0.00"}
                          </span>
                        </div>
                        <div className="mt-2 invoice-total d-flex">
                          <h6 className="w-50 mt-2 fw-bolder">{lan?.due} </h6>
                          <span className="mt-2 w-50 text-end me-1">
                            {grandTotal > 0 ? grandTotal : "0.00"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="mt-2 invoice-total d-flex">
                          <h6 className="w-50 mt-2 fw-bolder">
                            {lan?.grandTotal}
                          </h6>
                          <span className="mt-2 w-50 text-end me-3">
                            {grandTotal > 0
                              ? parseFloat(grandTotal || 0).toFixed(2)
                              : "0.00"}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className={`pos-invoice-cash px-2 mt-2`}>
                  {selectedInvoice?.payment_status === "Partially Paid" ? (
                    <></>
                  ) : (
                    <div className="d-flex justify-content-between">
                      <h6 className="pos-right-heading">
                        {lan?.cashCollection}
                      </h6>
                    </div>
                  )}

                  <div className="pos-invoice-cash-content m-2 p-2">
                    <div className="invoice-item mt-1 d-flex">
                      <span className="invoice-sub-item">
                        {lan?.grandTotal}:
                      </span>
                      <span className="invoice-item-price w-100 text-end">
                        {grandTotal > 0
                          ? parseFloat(grandTotal || 0).toFixed(2)
                          : "0.00"}
                      </span>
                    </div>
                    <div className="invoice-item mt-2 d-flex justify-content-between">
                      <span className="invoice-sub-item">
                        {lan?.paidAmount}:
                      </span>{" "}
                      <input
                        onChange={(e) => handlePay(e)}
                        type="number"
                        value={paidAmount}
                        className="form-control form-control-sm w-25 text-end"
                      />
                    </div>
                    {selectedInvoice?.id ? (
                      <></>
                    ) : (
                      <div className="invoice-item mt-1 d-flex ">
                        <span className="invoice-sub-item">Present Due:</span>{" "}
                        <span className="invoice-item-price text-end w-100">
                          {parseFloat(paidAmount) > 0
                            ? (
                                parseFloat(invoiceData?.due || 0) +
                                  parseFloat(allSubTotalWithoutDiscount || 0) -
                                  parseFloat(paidAmount || 0) -
                                  specialDiscount || 0
                              ).toFixed(2)
                            : (
                                parseFloat(invoiceData?.due || 0) +
                                  parseFloat(allSubTotalWithoutDiscount || 0) -
                                  specialDiscount || 0
                              ).toFixed(2)}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className={`mt-5 right-sidebar-btn-container px-2`}>
                  <div
                    style={{ margin: "12px -4px 12px -4px" }}
                    className="row"
                  >
                    <div className="col-4 ">
                      <button
                        onClick={() => {
                          setIsOpen(false);
                          setPaidAmount();
                          setPaymentMethod("Cash");
                        }}
                        className="custom-btn-outline w-100"
                      >
                        {lan?.cancel}
                      </button>
                    </div>
                    {paidAmount > 0 || paymentMethod === "Credit Payment" ? (
                      <div className="col-4 ">
                        {loading ? (
                          <button disabled className="custom-btn ms-1 w-100">
                            {lan?.payment}
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              handleUpdate();
                            }}
                            className="custom-btn ms-1 w-100"
                          >
                            {lan?.save}
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="col-4 ">
                        <button
                          onClick={() => toast.error("You need to pay first")}
                          title={"You need to pay first"}
                          className="custom-btn-disabled ms-1 w-100"
                        >
                          {lan?.save}
                        </button>
                      </div>
                    )}
                    <div className="col-4 ">
                      <button
                        onClick={() => {
                          handlePrintPreview();
                        }}
                        className="custom-btn w-100"
                      >
                        {lan?.preview}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ReactModal.Body>
      </ReactModal>
      <div ref={componentRef} className="sales-invoice">
        <Invoice
          isSpecialDiscount={isSpecialDiscount}
          invoice={invoice}
          salesDicount="0.00"
          grandTotal={grandTotal}
          paidAmount={paidAmount}
          returnAmount={returnAmount}
          specialDiscount={specialDiscount}
          delivery_charge={delivery_charge}
          invoiceData={invoiceData}
        />
      </div>
    </div>
  );
};

export default RightSidebar;
